module.exports = __webpack_public_path__ + "static/img/go-lottery.c3735eb6.png";